module.exports = __webpack_public_path__ + "img/ico-w-filter.22f3bd41.svg";